export const cx = (...xs) => xs.filter(Boolean).join(" ");
